import './scrollTop.scss';

const ScrollTop = () => {
    return <>
    <div className= "scroll-top">
        <a href="#menu"><i class="fas fa-chevron-up"></i></a>
    </div>
    </>
}
export default ScrollTop